/**
 * Date utility functions for JST <-> UTC conversion.
 *
 * - toJstYmdHmsFromUtcYmdHms : Display use only (Upload Date column)
 * - jstDateToUtcYmdHms       : Build API request filter values
 */

/**
 * Convert UTC 'YYYY-MM-DD HH:mm:ss' -> JST 'YYYY/MM/DD HH:mm:ss' by adding +9 hours.
 * For display use only (Upload Date (JST) column).
 *
 * @param {string} utcYmdHms - e.g. "2024-03-01 10:00:00"
 * @returns {string} - e.g. "2024/03/01 19:00:00"
 */
export function toJstYmdHmsFromUtcYmdHms(utcYmdHms) {
  const m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/.exec(utcYmdHms || "");
  if (!m) return "";

  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);
  const h = Number(m[4]);
  const mi = Number(m[5]);
  const s = Number(m[6]);

  const utcMillis = Date.UTC(y, mo, d, h, mi, s);
  const jst = new Date(utcMillis + 9 * 60 * 60 * 1000);

  const yy = jst.getUTCFullYear();
  const mm = String(jst.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(jst.getUTCDate()).padStart(2, "0");
  const hh = String(jst.getUTCHours()).padStart(2, "0");
  const mmi = String(jst.getUTCMinutes()).padStart(2, "0");
  const ss = String(jst.getUTCSeconds()).padStart(2, "0");

  return `${yy}/${mm}/${dd} ${hh}:${mmi}:${ss}`;
}

/**
 * Convert a JST date string 'YYYY-MM-DD' to a UTC datetime string 'YYYY-MM-DD HH:mm:ss'.
 * Used to build API request filter values.
 *
 * @param {string} jstYmd - e.g. "2024-03-01"
 * @param {"start"|"end"} boundary
 *   - "start": JST 00:00:00 -> UTC (subtract 9 hours)
 *   - "end":   JST 23:59:59 -> UTC (subtract 9 hours)
 * @returns {string} - e.g. "2024-02-29 15:00:00"
 */
export function jstDateToUtcYmdHms(jstYmd, boundary) {
  if (!jstYmd) return jstYmd;
  const time = boundary === "end" ? "23:59:59" : "00:00:00";
  const jst = new Date(`${jstYmd}T${time}+09:00`);
  const y = jst.getUTCFullYear();
  const m = String(jst.getUTCMonth() + 1).padStart(2, "0");
  const d = String(jst.getUTCDate()).padStart(2, "0");
  const hh = String(jst.getUTCHours()).padStart(2, "0");
  const mm = String(jst.getUTCMinutes()).padStart(2, "0");
  const ss = String(jst.getUTCSeconds()).padStart(2, "0");
  return `${y}-${m}-${d} ${hh}:${mm}:${ss}`;
}
